export const careBalanceStatusMap = new Map();

careBalanceStatusMap.set(1, "Active");
careBalanceStatusMap.set(2, "Pending");
careBalanceStatusMap.set(3, "Deleted");
careBalanceStatusMap.set(4, "Suspended");
careBalanceStatusMap.set(5, "Expired");
careBalanceStatusMap.set(6, "Deactivated");
careBalanceStatusMap.set(7, "Delayed");
